import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAssureAdvantageControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelEquipmentTypeMapping: Label;
    labelOnboardingInformation: Label;
    panelOnboarding: Panel;
    panelServer: Panel;
    sourceCarrierInsControl: DataSource;
    sourceInterfaceCodes: DataSource;
    switchAutoAddOnInvite: Switch;
    switchAutoApproveCarriers: Switch;
    switchEnableAdvances: Switch;
    switchIncludeInactiveCarriers: Switch;
    switchInsOnFile: Switch;
    switchIsActive: Switch;
    switchMonitorCarriers: Switch;
    switchSendCarriers: Switch;
    switchShowWatchdogStatus: Switch;
    tableAssureAdvantageEquipmentTypeMappings: Table;
    textboxAccountId: Textbox;
    textboxCarrierStatus: Textbox;
    textboxImageDirectory: Textbox;
    textboxLastOnboardingCheck: Textbox;
    textboxLastSyncDate: Textbox;
    textboxOnboardingPacketWebsiteUrl: Textbox;
    textboxPacketUrl: Textbox;
    textboxPassword: Textbox;
    textboxServerUrl: Textbox;
}
